import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { STATE_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface getProps {
  excludeCreatedStates?: boolean;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getStates = async (excludeCreatedStates?: boolean) =>
  await axiosAuth.get(`${STATE_API}/${excludeCreatedStates ? `?excludeCreatedStates=${excludeCreatedStates}` : ''}`);

const useGetStates = ({
    excludeCreatedStates,
    queryParams
}: getProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(excludeCreatedStates),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetStates;
